import React, { useEffect, useState } from "react";
import { ReactComponent as VerticalGapIcon } from 'assets/icons/constructor-create-icons/VERTICAL_GAP.svg';
import { ReactComponent as FeedIcon } from 'assets/icons/constructor-create-icons/FEED.svg';
import s from "./space-component.module.scss";
import MenuButton from "pages/report-constructor/items/menu-button/menu-button";
import { InputNumber } from "commons/input-controls";
import SaveButton from "pages/report-constructor/items/save-button/save-button";

const SpaceComponent = (props) => {
    const [parameters, setParameters] = useState(props.parameters ? props.parameters : null);
   // const [type, setType] = useState(props.type ? props.type : '');
    const [spaceType, setSpaceType] = useState(props.type ? props.type : 'PAGE_BREAK');
    const [gapLine, setGapLine] = useState(props.parameters && props.parameters.GAP_LINES ? props.parameters.GAP_LINES : null);
    const [isShowVerticalGaps, setIsShowVerticalGaps] = useState(false);

    useEffect(() => {
        setParameters(props.parameters ? props.parameters : null);
        setGapLine(props.parameters && props.parameters.GAP_LINES ? props.parameters.GAP_LINES : null);
    }, [props]);

    const setGapLines = (gapLine) => {
        let params = {GAP_LINES: gapLine}
        setGapLine(gapLine)
        updateParameters(spaceType, 'GAP_LINES', gapLine)
    }

    const updateParameters = (type, parameter, value) => {
        let params = parameters;
        params[parameter] = value;
        if(value === ''){
            delete params[type][parameter];
        }
        setParameters(params)
    }

    const changeSpaceType = (spaceType) => {
        setSpaceType(spaceType);
    }


    const saveSpace = (type) => {
        props.updateTemplateComponents(parameters, type);
    }

    return (
        <div className={s.SpaceComponent}>
            {/*<div className={s.SpaceComponentButtons}>
                <MenuButton title={'Разрыв страницы'} icon={<VerticalGapIcon />} changeSpaceType={'PAGE_BREAK'} type={'PAGE_BREAK'} callback={changeSpaceType}/>
                <MenuButton title={'Новая строка'} icon={<FeedIcon />} changeSpaceType={'VERTICAL_GAP'} type={'VERTICAL_GAP'} callback={changeSpaceType}/>
            </div>*/}
            {spaceType === 'VERTICAL_GAP' && <div className={s.gapsLine}><InputNumber min={1} value={gapLine} callback={setGapLines}/></div> }
        </div>
    )
}

export default SpaceComponent;